import React from "react";

const RTD_URL = "https://www.righttodigital.com";

export default function Footer() {
  return (
    <footer
      className="w-full text-center"
      style={{
        backgroundColor: "var(--rtd-navy)",
        borderTop: "1px solid var(--rtd-navy-card)",
        padding: 24,
      }}
      data-testid="site-footer"
    >
      <a
        href={RTD_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2.5 group"
        data-testid="footer-wordmark-link"
        aria-label="Right to Digital — opens in a new tab"
      >
        <span
          aria-hidden="true"
          style={{ width: 4, height: 18, backgroundColor: "var(--rtd-gold)", borderRadius: 2 }}
        />
        <img
          src="/rtd-logo.png"
          alt="Right to Digital"
          style={{ height: 18, width: "auto", transition: "opacity 200ms ease" }}
          className="group-hover:opacity-80"
        />
      </a>
      <p
        className="font-body"
        style={{ fontSize: 12, color: "#7A94A8", marginTop: 12 }}
      >
        First-Party Data + Signal Engineering · righttodigital.com
      </p>
    </footer>
  );
}
